import {
  MessageFromParent,
  MessageFromParentType,
  MessageToParent,
} from '@stripe-internal/support-conversations-controller';

export type ParentMessageListenerFn = (message: MessageFromParent) => void;

export interface ParentMessageBus {
  // Send a message to the parent
  post: (message: MessageToParent) => void;

  request: (
    message: MessageToParent,
    expectedResponseType: MessageFromParentType,
  ) => Promise<MessageFromParent>;

  // Request the latest analytics event ID from the parent
  requestAnalyticsEventId: () => Promise<string | null>;

  // Add and remove persistent message listeners
  addListener: (listener: ParentMessageListenerFn) => void;
  removeListener: (listener: ParentMessageListenerFn) => void;
}

export const NoMessageBus: ParentMessageBus = {
  post(_message: MessageToParent): void {
    throw new Error('Function not implemented.');
  },
  addListener(_listener: ParentMessageListenerFn): void {
    throw new Error('Function not implemented.');
  },
  removeListener(_listener: ParentMessageListenerFn): void {
    throw new Error('Function not implemented.');
  },
  request(): Promise<MessageFromParent> {
    throw new Error('Function not implemented.');
  },
  requestAnalyticsEventId(): Promise<string | null> {
    return Promise.resolve(null);
  },
};
